module.exports = __webpack_public_path__ + "player1.png";